(function policyMarkdownNormalizer() {
  const containerSelector = '.shopify-policy__container';
  const markerPattern = /^\s*(#{1,6})\s+(.+)$/;
  const listPattern = /^\s*[-*+]\s+(.+)$/;
  const orderedListPattern = /^\s*(\d+)\.\s+(.+)$/;

  function safeHref(value) {
    const href = String(value || '').trim();
    if (href.startsWith('/') || href.startsWith('#')) return href;
    try {
      const url = new URL(href, window.location?.href || 'https://example.invalid');
      return url.protocol === 'http:' || url.protocol === 'https:' ? href : '';
    } catch {
      return '';
    }
  }

  function appendInline(document, target, source, prefix = '') {
    let pendingPrefix = prefix;
    for (const node of source.childNodes) {
      if (node.nodeType === 3) {
        let value = node.textContent;
        if (pendingPrefix && value.startsWith(pendingPrefix)) {
          value = value.slice(pendingPrefix.length);
          pendingPrefix = '';
        }
        const parts = value.split('**');
        parts.forEach((part, index) => {
          if (index % 2 === 1) {
            const strong = document.createElement('strong');
            strong.textContent = part;
            target.append(strong);
          } else if (part) {
            target.append(document.createTextNode(part));
          }
        });
      } else if (node.nodeType === 1 && node.tagName === 'A') {
        const href = safeHref(node.getAttribute('href'));
        if (href) {
          const link = document.createElement('a');
          link.setAttribute('href', href);
          if (node.getAttribute('target') === '_blank') {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
          }
          link.textContent = node.textContent;
          target.append(link);
        } else {
          target.append(document.createTextNode(node.textContent));
        }
      } else {
        target.append(document.createTextNode(node.textContent));
      }
    }
  }

  function paragraphText(node) {
    return node.textContent || '';
  }

  function approvedPolicyBodies(container) {
    const directBodies = [...container.children].filter((node) => node.classList?.contains('shopify-policy__body'));
    return directBodies.length > 0 ? directBodies : [container];
  }

  function normalizeContainer(container, document) {
    if (container.dataset.alvornPolicyNormalized === 'true') return false;
    const policyBodies = approvedPolicyBodies(container);
    const paragraphs = policyBodies.flatMap((policyBody) => [...policyBody.children].filter((node) => node.tagName === 'P'));
    if (!paragraphs.some((paragraph) => markerPattern.test(paragraphText(paragraph)) || listPattern.test(paragraphText(paragraph)) || orderedListPattern.test(paragraphText(paragraph)) || paragraphText(paragraph).includes('**'))) return false;

    let changed = false;
    for (let index = 0; index < paragraphs.length; index += 1) {
      const paragraph = paragraphs[index];
      if (!paragraph.isConnected) continue;
      const heading = paragraphText(paragraph).match(markerPattern);
      if (heading) {
        const replacement = document.createElement(`h${Math.min(heading[1].length, 6)}`);
        appendInline(document, replacement, paragraph, heading[0].slice(0, heading[0].length - heading[2].length));
        paragraph.replaceWith(replacement);
        changed = true;
        continue;
      }
      const list = paragraphText(paragraph).match(listPattern);
      const orderedList = paragraphText(paragraph).match(orderedListPattern);
      if (list || orderedList) {
        const replacement = document.createElement(orderedList ? 'ol' : 'ul');
        let current = paragraph;
        paragraph.before(replacement);
        while (current?.tagName === 'P') {
          const item = paragraphText(current).match(orderedList ? orderedListPattern : listPattern);
          if (!item) break;
          const listItem = document.createElement('li');
          appendInline(document, listItem, current, item[0].slice(0, item[0].length - item[orderedList ? 2 : 1].length));
          replacement.append(listItem);
          const next = current.nextElementSibling;
          current.remove();
          current = next;
        }
        changed = true;
        continue;
      }
      if (paragraphText(paragraph).includes('**')) {
        const replacement = document.createElement('p');
        appendInline(document, replacement, paragraph);
        paragraph.replaceWith(replacement);
        changed = true;
      }
    }
    if (changed) container.dataset.alvornPolicyNormalized = 'true';
    return changed;
  }

  function normalize(document) {
    if (!document?.querySelectorAll) return 0;
    return [...document.querySelectorAll(containerSelector)].reduce((count, container) => count + Number(normalizeContainer(container, document)), 0);
  }

  function initialize() {
    normalize(document);
  }

  window.AlvornPolicyMarkdownNormalizer = Object.freeze({ normalize });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
